Vue.asyncComponent('cms-media-inspector', {
    props: {
        mediaId: {
            type: String,
            default: '',
            required: false,
        },
        relationString: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: false,
            media: null,
            isImage: false,
            thumbnail: null,
            focalPoint: null,
            publications: [],
            blocks: [],
            showSwitchWorkspace: false,
            activePublication: null
        }
    },
    methods: {
        /**
         * Fetch the data
         * @returns {Promise<void>}
         */
        async fetchData() {
            this.loading = true;
            const path = this.$getSetting('paths.baseCms') + '/media/inspect/' + this.mediaId;
            const result = await this.$get(path);

            this.media = result.media;
            this.isImage = result.isImage;
            this.focalPoint = result.focalPoint;
            this.thumbnail = result.thumbnail;
            this.publications = result.publications;
            this.blocks = result.blocks;

            this.loading = false;
        },
        /**
         * Go to publication Form
         * @param publication
         */
        goToForm(publication) {
            if (! publication.isInCurrentWorkspace) {
                this.activePublication = publication;
                this.showSwitchWorkspace = true;
                return;
            }
            //redirect to the new relation state
            this.$router.push(this.getPublicationFormRoute(publication));
        },
        /**
         * Go to block setitng Form
         * @param block
         */
        goToSettingForm(block) {
            const routeData = this.$router.resolve(this.getBlockSettingFormRoute(block));
            window.open(routeData.href, '_blank');
        },
        goToFormInDifferentWorkspace() {
            const route = this.$router.resolve(this.getPublicationFormRoute(this.activePublication));

            window.location.href = this.activePublication.routeAll + route.href;
            this.showSwitchWorkspace = false;
            this.activePublication = null;
        },
        /**
         * Get Publication form route
         * @param publication
         * @returns {{name, params: ({relationString}|*)}}
         */
        getPublicationFormRoute(publication) {
            let params = this.$route.params;
            // add the formDefinition & object Id to the relation ID

            if (params.relationString) {
                params.relationString += ':';
            } else {
                params.relationString = '';
            }

            params.relationString += 'form:' + publication.bundle + ':' + publication.definition + ':' + publication.id;

            return {name: this.$route.name, params: params};
        },
        getBlockSettingFormRoute(block) {
            return {
                name: 'blueprint-block-form',
                params: {
                    blueprintId: block.blueprintId,
                    blockType: block.blockType,
                    referenceId: block.blockId,
                    hashId: block.blockId,
                },
                query: {
                    verticalId: block.verticalId
                }
            };
        },
        /**
         * Trigger close
         */
        triggerClose() {
            this.$router.back();
        }
    },
    created() {
        this.fetchData();
    }
}, 'cms/media/cms-media-inspector.html');